export default {
  RETAILERS: 'RETAILERS',
  USERS: 'USERS',
  AUDIT_LOGS: 'AUDIT_LOGS',
  ENFORCEMENT: 'ENFORCEMENT',
  LICENSES: 'LICENSES',
};
